import React from "react";
import { ProductDetailPage } from "../../../SharedPages/ProductDetailPage/ProductDetailPage";

export const SellerAdminProductDetail = () => {
  return <ProductDetailPage />;
};
